import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import { toast } from "react-toastify";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import { getItemToken } from "../../../Utils/localStorageUtils";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function AddPublisher() {
  const { fetchRequest, globalImageUplaodAPI } = useMyContext()
  const headers = getItemToken('access_token')
  const baseURL = process.env.REACT_APP_Baseurl
  const { id } = useParams()
  const [formData, setFormData] = useState(
    {
      artist_name: "",
      artist_slug: "",
      artist_email: "",
      description: ""
    })
  const [formDataError, setFormDataError] = useState({})
  const [coverImageFile, setCoverImageFile] = useState(null);
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [loading, setLoading] = useState(true)
  const combinedRef = useRef([]);
  const navigate = useNavigate();
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const setRef = (element, index) => {
    if (element) {
      combinedRef.current[index] = element;
    }
  };

  const handleAdd = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      for (const key in formData) {
        formDataAdd[key] = formData[key];
      }
      const response = await axios.post(`${baseURL}/admin/song-writer/store`, formDataAdd, { headers: headers });
      const result = response?.data;
      if (result?.status) {
        if (coverImageFile) {
          await handleImageUpload(result?.id)
        }
        setShowOverlay(false);
        toast.success(result?.message)
        navigate("/artists-songwriter");
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }

  const handleUpdate = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      for (const key in formData) {
        if (['artist_name', 'artist_slug', 'artist_email', 'description'].includes(key)) {
          formDataAdd[key] = formData[key]
        }
      }
      const response = await axios.post(`${baseURL}/admin/song-writer/update/${id}`, formDataAdd, { headers: headers });
      const result = response?.data;
      if (result?.status) {
        if (coverImageFile) {
          await handleImageUpload(id)
        }
        setWithOutRefresh(!withOutRefresh)
        setShowOverlay(false);
        toast.success(result?.message)
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }


  const handleImageUpload = async (id) => {
    try {
      const formData = new FormData();
      const imageFields = [];
      formData.append("id", id);
      formData.append("modelName", "SongWriter");
      formData.append("image", coverImageFile);
      imageFields.push("image");
      imageFields.forEach((field) => {
        formData.append('imageFields[]', field);
      });
      const imageApi = globalImageUplaodAPI()
      const response = await fetchRequest({ method: 'POST', url: imageApi, data: formData });
      if (!response?.status) {
        toast.error(response?.message)
      }
      setCoverImageFile(null)
    } catch (err) {
      console.error(err)
    }
  }

  const handleStore = async () => {
    if (formValidation()) {
      if (!id) {
        await handleAdd();
      }
      else {
        handleUpdate()
      }

    } else {
      console.log("Form validation failed ");
    }
  }


  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.artist_name) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        artist_name: "Artist Writer cannot be empty.",
      }));
      combinedRef.current['artist_name'].focus()
      formIsValid = false;
    } else if (!formData?.artist_slug) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        artist_slug: "Slug  Musician cannot be empty.",
      }));
      combinedRef.current['artist_slug'].focus()
      formIsValid = false;
    }
    if (!formData?.artist_email) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        artist_email: "Email cannot be empty.",
      }));
      combinedRef.current['artist_email'].focus()
      formIsValid = false;
    } else if (!regex.test(formData?.artist_email)) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        artist_email: "Email format is incorrect.",
      }));
      combinedRef.current['artist_email'].focus()
      formIsValid = false;
    }
    return formIsValid;
  }

  // api end
  // function start
  const handleBlurtitle = () => {
    if (!formData?.artist_slug) {
      generateSlug(formData?.artist_name);
    }
  };

  const generateSlug = async (artist_name) => {
    const slug = await slugGenerator(artist_name)
    setFormData((prevFormData) => ({
      ...prevFormData,
      artist_slug: slug,
    }));
  };

  const handleInputKeyDowntitle = (event) => {
    if (!formData?.artist_slug) {
      if (event.key === "Enter" || event.key === "Tab") {
        generateSlug(formData?.artist_name);
      }
    }
  };

  const handleAutoFillChangetitle = (event) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      artist_slug: event.target.value,
    }));
    setFormDataError((prevFormData) => ({
      ...prevFormData,
      [event.target.name]: "",
    }));
  };

  const handleBlurTitleEdit = () => {
    generateSlug(formData?.artist_slug);
  };

  const handleInput = async (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    setFormDataError((prevFormData) => ({
      ...prevFormData,
      artist_name: "",
      artist_slug: "",
      artist_email: "",
      artist_type: ""
    }));
  }

  //Handle Image upload
  const handleCoverImageChange = (event) => {
    const selectedFile = event.target.files;
    if (selectedFile.length > 0) {
      const newFile = selectedFile[0];
      const reader = new FileReader();
      reader.onload = () => {
        setCoverImageFile(newFile);
      };
      reader.readAsDataURL(newFile);
    } else {
    }
  };

  const EditData = async () => {
    const response = await axios.get(`${baseURL}/admin/song-writer/edit/${id}`, { headers: headers });
    const result = response?.data;
    const editResult = result?.artist;
    if (response?.data?.status) {
      setFormData(editResult)
      setLoading(false);
    }
    else {
      console.error(result?.message)
      setLoading(false);
    }
  };

  const handleClearSelectFile = (value) => {
    setCoverImageFile(null)
  }


  // function end
  useEffect(() => {
    if (id) {
      EditData()
    }
  }, [withOutRefresh]);

  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={!id ? "Create Song Writer" : "Edit Song Writer"} saveText={!id ? "Add Song Writer" : "Update Song Writer"} saveMethod={handleStore} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="Create Song Writer" />
            <MessageLabel text="Artist Musician" className="mandatorySimple" />
            <input type="text" name="artist_name" value={formData?.artist_name} onChange={handleInput} placeholder="Artist Musician" ref={(el) => setRef(el, 'artist_name')} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} className="rs-input form-control-lg custom-placeholder  theme-text-color mb-3" />
            {formDataError?.artist_name && (<MessageBox text={`${formDataError?.artist_name}`} classname='errorred mb-2 d-block' />)}

            <MessageLabel text='Artist Slug' />
            <input type="text" name="artist_slug" id="artist_slug" value={formData?.artist_slug} onChange={handleAutoFillChangetitle} ref={(el) => setRef(el, 'artist_slug')} onBlur={handleBlurTitleEdit} placeholder="slug" className="mb-3 rs-input form-control-lg custom-placeholder  theme-text-color " />
            {formDataError?.artist_slug && (<MessageBox text={`${formDataError?.artist_slug}`} classname='errorred mb-2 d-block' />)}

            <MessageLabel text="Artist Email" className="mandatorySimple" />
            <input type="text" name="artist_email" value={formData?.artist_email} ref={(el) => setRef(el, 'artist_email')} onChange={handleInput} placeholder="Email" className="rs-input form-control-lg custom-placeholder  theme-text-color  mb-3" />
            {formDataError?.artist_email && (<MessageBox text={`${formDataError?.artist_email}`} classname='errorred mb-2 d-block' />)}

          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={"Thumbnail Image"} />
            <MessageLabel text={"Image"} />
            <AdminImageUploadZone
              onChange={handleCoverImageChange}
              selectedFile={coverImageFile}
              uploadedImage={formData?.image}
              onDelete={handleClearSelectFile}
              fileInputRef={setRef}
              name="image"
              id={id} />
          </Wrapper>
          <Wrapper>
            <MessageLabel text={"Description"} />
            <textarea rows={20} type="text" name="description" id="description" value={formData?.description} onChange={handleInput} ref={(el) => setRef(el, 'description')} onBlur={handleBlurTitleEdit} placeholder="description" className="mb-3 rs-input form-control-lg custom-placeholder theme-bg-color-secondary theme-text-color border-0" />
          </Wrapper>
        </RightWrapper>
        <AdminCustomButton className='px-3 py-1 m-0 ms-auto' saveMethod={handleStore} saveText={!id ? "Add Song Writer" : "Update Song Writer"} />
      </FormContainer>
    </>
  );
}
export default AddPublisher;